import { CANCELLATION_REASON } from '@allocab/allocab-commons-shared-types';
import type { AskCancelOutput, ConfirmCancelInput } from '@allocab/allocab-passenger-shared-types';
import { useState } from 'react';

import { TextInput } from '../../../components/atomic/TextInput';
import { PrimaryButton } from '../../../components/button/PrimaryButton';
import { SecondaryButton } from '../../../components/button/SecondaryButton';
import { ModalTitle } from '../../../components/Modal';
import { RadioButton } from '../../../components/RadioButton';
import { t } from '../../../services/translation/translation';

type Props = {
  tripKey: string;
  cancelRequest: AskCancelOutput;
  onCancel: () => void;
  onConfirm: (_input: ConfirmCancelInput) => void;
  isLoading: boolean;
};

export const ReasonStep = ({ cancelRequest, onCancel, onConfirm, isLoading, tripKey }: Props) => {
  const [selectedReason, setSelectedReason] = useState<CANCELLATION_REASON>(cancelRequest.reasons[0].key);
  const [cancellationDetail, setCancellationDetail] = useState<string>('');

  return (
    <>
      <ModalTitle title={t('cancel-modal.reason-title')} />
      <p className="text-text/70 text-center mb-4">{t('cancel-modal.reason-subtitle')}</p>
      <input type="hidden" name="cancelToken" value={cancelRequest.cancelToken} />
      <div className="flex flex-col space-y-4 mb-4">
        {cancelRequest.reasons.map(reason => (
          <RadioButton
            key={reason.key}
            name="reason"
            label={reason.label}
            value={reason.key}
            onChange={e => setSelectedReason(e.currentTarget.value as CANCELLATION_REASON)}
          />
        ))}
        {selectedReason === 'OTHER' ? (
          <TextInput
            type="text"
            value={cancellationDetail}
            onChange={e => setCancellationDetail(e.currentTarget.value)}
            placeholder={t('cancel-modal.other-placeholder') ?? undefined}
          />
        ) : null}
      </div>
      <div className="flex flex-row space-x-2">
        <SecondaryButton onClick={onCancel} className="flex-1" isDisabled={isLoading}>
          {t('common.back')}
        </SecondaryButton>
        <PrimaryButton
          className="flex-1"
          onClick={() =>
            onConfirm({
              key: tripKey,
              reason: selectedReason,
              cancelToken: cancelRequest.cancelToken,
              cancellationDetail: cancellationDetail || undefined,
            })
          }
          isLoading={isLoading}
        >
          {t('common.yes')}
        </PrimaryButton>
      </div>
    </>
  );
};
